import React, { useRef, useEffect } from 'react';
import { useConfig, useDisconnect, useConnect } from 'wagmi';
import { useDynamicContext } from '@dynamic-labs/sdk-react-core';

const SyncDynamicWagmi = ({ children, connector, }) => {
    const { status: clientStatus } = useConfig();
    const { disconnect } = useDisconnect();
    const { internalEvents, walletConnector } = useDynamicContext();
    const lastConnectedConnectorId = useRef(undefined);
    const { connect } = useConnect();
    useEffect(() => {
        const events = internalEvents.current;
        const handleDisconnect = () => {
            lastConnectedConnectorId.current = undefined;
            disconnect();
        };
        events.on('clearPrimaryWallet', handleDisconnect);
        return () => {
            events.off('clearPrimaryWallet', handleDisconnect);
        };
    }, [disconnect, internalEvents]);
    useEffect(() => {
        if (walletConnector &&
            connector &&
            (connector === null || connector === void 0 ? void 0 : connector.id) !== lastConnectedConnectorId.current) {
            lastConnectedConnectorId.current = connector.id;
            connect({ connector });
        }
    }, [
        clientStatus,
        connect,
        connector,
        disconnect,
        lastConnectedConnectorId,
        walletConnector,
    ]);
    // use React.createElement to prevent bunding react/jsx-runtime,
    // which is not compatible when bundling apps using React 17
    return React.createElement(React.Fragment, null, children);
};

export { SyncDynamicWagmi };
